import React from "react";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import {
  AESEncryption,
  ApiResDecrypt,
  validateEmail,
} from "../../CommonMethhods/CommonMethods";
import { Login_Page } from "../../Configuration/API_URL";
import { Link } from "react-router-dom";
import Formnav from "./FormNav";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Constants } from "../../CommonMethhods/Constants";
import axiosInstance from "../../CommonMethhods/axiosInstance";

function ForgetEmailForm() {
  const [userEmail, setUserEmail] = useState("");
  const [emailError, setEmailError] = useState(false);

  let navigate = useNavigate();
  let response;

  const forgotUserId = async () => {
    let payloadValue = { email: userEmail };
    let encPayload = AESEncryption(payloadValue);

    try {
      response = await axiosInstance.post(
        Login_Page.Forget_UserName_URL,

        `"${encPayload}"`,
      );
      const res = ApiResDecrypt(response?.data);
      if (res.status === 0) {
        toast.error("Failed to send mail");
      } else {
        toast.success("Mail sent successfully");
        setTimeout(() => {
          navigate("/");
        }, 2000);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleForgotUsername = (e) => {
    e.preventDefault();

    const validEmail = validateEmail(userEmail);
    if (validEmail) {
      setEmailError(false);
      forgotUserId(userEmail);
    } else {
      setEmailError("Enter a valid email address");
    }
  };

  const handleUserEmail = (e) => {
    setUserEmail(e.target.value);
  };

  return (
    <>
      <div className="form-wrapper">
        <form
          className="form login-form"
          onSubmit={handleForgotUsername}
          noValidate
        >
          <Formnav />
          <h2 className="form-title">{Constants.Recover_Id}</h2>
          <h4 className="form-info">{Constants.UserId_Sent_On_Email}</h4>
          <label htmlFor="email" className="form-label">
            {Constants.EMAIL} <span className="mandatory-label">*</span>
          </label>
          <input
            type="email"
            className="form-input"
            placeholder="Enter your Email ID"
            onChange={handleUserEmail}
            autoComplete="on"
          />
          <p className="forget-link">
            <span>{emailError}</span>
            <Link to="/">{Constants.Back_Login}</Link>
          </p>

          {/* <!-- submit btn --> */}
          <button className="form-submit" type="submit">
            {Constants.Submit}
          </button>
        </form>
      </div>
    </>
  );
}

export default ForgetEmailForm;
